import React, { useState, useEffect } from 'react';
import { useLoading } from './LoadingContext';
import LoadingCompass from '../../components/loading/LoadingCompass';
import { StringKeys } from '../../resources/strings/StringKeys';
import { useTranslation } from 'react-i18next';

const LoadingIndicator = () => {
  const {
    normalUserSignalRStatus,
    safeguardUserSignalRStatus,
    pageLoading,
    setLoadingText,
    loadingText,
    setTransitionComplete,
  } = useLoading();
  const [showLoading, setShowLoading] = useState(false);
  const [isReadyToEnter, setIsReadyToEnter] = useState(false);
  const [userClickedEnter, setUserClickedEnter] = useState(false);
  const { t } = useTranslation();

  // Check if loading is complete and set ready state
  useEffect(() => {
    if (
      normalUserSignalRStatus !== 'Connected' &&
      safeguardUserSignalRStatus !== 'Connected' &&
      pageLoading
    ) {
      setShowLoading(true);
      setIsReadyToEnter(false);
    } else if (
      (normalUserSignalRStatus === 'Connected' ||
        safeguardUserSignalRStatus === 'Connected') &&
      !pageLoading
    ) {
      setShowLoading(true);
      setIsReadyToEnter(true);
    }
  }, [normalUserSignalRStatus, safeguardUserSignalRStatus, pageLoading]);

  // Handle the fade-out after user clicks enter
  useEffect(() => {
    let timeoutId;
    if (userClickedEnter) {
      timeoutId = setTimeout(() => {
        setShowLoading(false);
        setTransitionComplete(true);
        setLoadingText(`${t(StringKeys.LOADING)}`);
      }, 1000);
    }

    return () => clearTimeout(timeoutId);
  }, [userClickedEnter, t]);

  const handleEnterClick = () => {
    setUserClickedEnter(true);
  };

  if (!showLoading) return null;

  return (
    <div className={`loading-container ${userClickedEnter ? 'fade-out' : ''}`}>
      <LoadingCompass
        loadingText={loadingText}
        isReadyToEnter={isReadyToEnter}
        onEnterClick={handleEnterClick}
      />
    </div>
  );
};

export default LoadingIndicator;
